<!-- Generated by GitHub Copilot - Sep-30-2026 -->
<div class="audit-log">
  <!-- Loading overlay -->
  @if (isLoading) {
  <div class="overlay" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <p class="text-load">&nbsp;&nbsp; Loading...</p>
  </div>
  }

  <div [class.blur]="isLoading">
  <!-- Toolbar: search + filters + reset -->
  <div class="audit-toolbar">
    <div class="audit-search-wrapper">
      <input
        type="text"
        class="audit-search-input"
        placeholder="Search by User, Action, Record..."
        aria-label="Search audit log"
        [(ngModel)]="search"
        (ngModelChange)="onSearchChange($event)" />
      <mat-icon class="audit-search-icon" aria-hidden="true">search</mat-icon>
    </div>

    <div class="audit-field">
      <label class="audit-field-label" for="audit-module">Module</label>
      <app-multi-select-dropdown
        class="audit-multi-select"
        inputId="audit-module"
        label="Module"
        allLabel="All Module"
        [options]="moduleOptions"
        [selected]="selectedModules"
        (selectedChange)="onModuleChange($event)" />
    </div>

    <div class="audit-field">
      <label class="audit-field-label" for="audit-action">Action Type</label>
      <app-multi-select-dropdown
        class="audit-multi-select"
        inputId="audit-action"
        label="Action Type"
        allLabel="All Actions"
        [options]="actionTypeOptions"
        [selected]="selectedActionTypes"
        (selectedChange)="onActionTypeChange($event)" />
    </div>

    <div class="audit-field">
      <label class="audit-field-label" for="audit-status">Status</label>
      <select id="audit-status" class="audit-select audit-status-select" [(ngModel)]="statusFilter">
        <option value="All">All Statuses</option>
        <option value="Success">Success</option>
      </select>
    </div>

    <div class="audit-field">
      <label class="audit-field-label" for="audit-start">Start Date</label>
      <div class="audit-date-wrapper">
        <input
          id="audit-start"
          type="text"
          class="audit-date"
          [value]="formatFilterDate(startDate)"
          placeholder="DD-MMM-YYYY"
          readonly />
        <input
          #startDatePicker
          type="date"
          class="audit-native-date"
          aria-label="Choose start date"
          [(ngModel)]="startDate"
          (ngModelChange)="onFilterChange()" />
        <button type="button" class="audit-calendar-btn" aria-label="Open start date calendar" (click)="openDatePicker(startDatePicker)">
          <mat-icon>calendar_today</mat-icon>
        </button>
      </div>
    </div>

    <div class="audit-field">
      <label class="audit-field-label" for="audit-end">End Date</label>
      <div class="audit-date-wrapper">
        <input
          id="audit-end"
          type="text"
          class="audit-date"
          [class.audit-date-invalid]="dateRangeError"
          [attr.aria-invalid]="dateRangeError ? 'true' : null"
          [value]="formatFilterDate(endDate)"
          placeholder="DD-MMM-YYYY"
          readonly />
        <input
          #endDatePicker
          type="date"
          class="audit-native-date"
          aria-label="Choose end date"
          [min]="startDate || null"
          [(ngModel)]="endDate"
          (ngModelChange)="onFilterChange()" />
        <button type="button" class="audit-calendar-btn" aria-label="Open end date calendar" (click)="openDatePicker(endDatePicker)">
          <mat-icon>calendar_today</mat-icon>
        </button>
      </div>
    </div>

    <button type="button" class="audit-reset-btn" (click)="resetFilters()">Reset</button>
  </div>

  @if (dateRangeError) {
  <div class="audit-date-error" role="alert">{{ dateRangeError }}</div>
  }

  <!-- Grid -->
  <div class="audit-table-wrapper">
    <table class="audit-table">
      <thead>
        <tr>
          @for (col of columns; track col.key) {
          <th (click)="sort(col.key)" [class.active]="sortColumn === col.key">
            <div class="th-cell">
              <span class="th-label">{{ col.label }}</span>
              <span class="material-symbols-outlined arrow-icon">{{ getSortIcon(col.key) }}</span>
            </div>
          </th>
          }
          <th class="action-col">Action</th>
        </tr>
      </thead>

      <tbody>
        @for (log of pagedLogs; track log.logId) {
        <tr>
          <td class="col-log-id"><span class="log-id">{{ log.logId }}</span></td>
          <td>{{ log.dateTime | date:'dd-MMM-yyyy HH:mm' }}</td>
          <td>{{ log.performedBy }}</td>
          <td>
            <span class="module-badge" [class]="moduleBadgeClass(log.module)">{{ log.module }}</span>
          </td>
          <td>{{ log.actionPerformed }}</td>
          <td>
            <span class="status-badge" [class]="statusBadgeClass(log.status)">{{ log.status }}</span>
          </td>
          <td class="action-col">
            <span
              class="material-symbols-outlined view-icon"
              role="button"
              tabindex="0"
              title="View"
              aria-label="View audit log entry"
              (click)="viewLog(log)"
              (keyup.enter)="viewLog(log)">visibility</span>
          </td>
        </tr>
        }
        @if (filteredLogs.length === 0) {
        <tr>
          <td colspan="7" class="audit-empty">{{ emptyMessage }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="audit-pagination">
    <div class="audit-pagination-control">
      <span>Show</span>
      <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()" aria-label="Items per page">
        <option *ngFor="let size of [10, 25, 50]" [ngValue]="size">{{ size }}</option>
      </select>
      <span>Items/page</span>
    </div>
    <div class="audit-pagination-control">
      <span>Go to page</span>
      <select class="audit-goto-select" [(ngModel)]="goToPageInput" (ngModelChange)="goToPage()" aria-label="Go to page">
        @for (page of pageNumbers; track page) {
        <option [ngValue]="page">{{ page }}</option>
        }
      </select>
    </div>
    <div class="audit-page-buttons">
      <button class="audit-pg-arrow" [disabled]="currentPage === 1 || !filteredLogs.length" (click)="changePage(1)" aria-label="First page">
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      </button>
      <button class="audit-pg-arrow" [disabled]="currentPage === 1 || !filteredLogs.length" (click)="changePage(currentPage - 1)" aria-label="Previous page">
        <mat-icon>chevron_left</mat-icon>
      </button>
      @for (item of visiblePageItems; track $index) {
        @if (item === 'ellipsis') {
        <span class="audit-page-ellipsis">...</span>
        } @else {
        <button class="audit-page-number" [class.active]="item === currentPage" (click)="changePage(item)">{{ item }}</button>
        }
      }
      <button class="audit-pg-arrow" [disabled]="currentPage === totalPages || !filteredLogs.length" (click)="changePage(currentPage + 1)" aria-label="Next page">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button class="audit-pg-arrow" [disabled]="currentPage === totalPages || !filteredLogs.length" (click)="changePage(totalPages)" aria-label="Last page">
        <mat-icon>keyboard_double_arrow_right</mat-icon>
      </button>
    </div>
  </div>
  </div>
</div>
